import removeWishlist from '../removeWishlist';

export default async function getProductGidFromHandle(handle) {
  try {
    const res = await fetch(`/products/${handle}.json`);
    if (res.ok) {
      const data = await res.json();
      const productId = data.product?.id;
      if (productId) return `gid://shopify/Product/${productId}`;
    } else {
      await removeWishlist(handle);
      console.info('[Wishlist] Product handle removed: ', handle);
      return null;
    }
  } catch (error) {
    console.error('[Wishlist] Failed to fetch product id', error);
    return null;
  }
}
